import styled from "styled-components";

export const ContactGroup = styled.div`
  position: relative;
  width: 100%;
`;

export const ContactGroupItem = styled.div`
  margin: 0 0 20px;
  position: relative;
  width: 100%;

  &:last-child {
    margin: 0;
  }
`;
